import AppHeader from '../AppHeader'

var utils = require('../../utils')

//
// 給与・賞与明細 一覧（F-PAY-03）＋ Excel取込（F-PAY-01）
//
// 取込は同じ画面の折りたたみパネルで行い、完了したら一覧を取り込んだ支給日で絞り込んで再読込する。
//
export default {
  name: 'payroll-list',
  created () {
    if (!this.canManagePayroll) {
      this.$router.push({ path: '/' })
      return
    }
    this.search()
  },
  data () {
    return {
      loginId: '',
      payDate: null,
      documentType: '',
      searchCallbackFlag: false,
      // 取込パネル
      importOpen: false,
      importDocumentType: 'salary',
      importPayDate: null,
      importFile: null,
      importing: false,
      inputClear: true
    }
  },
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isHrManager () {
      return window.localStorage.getItem('user_authority') === '5'
    },
    canManagePayroll () {
      return this.isSystemManagement || this.isHrManager
    },
    documents () {
      return this.$store.getters.payrollDocuments
    },
    document () {
      return this.$store.getters.payrollDocument
    },
    forbidden () {
      return this.$store.getters.payrollForbidden
    },
    notify () {
      return this.$store.getters.payrollNotify
    },
    importResult () {
      return this.$store.getters.payrollImportResult
    },
    // 既存の期限日入力と同じ yyyy-mm-dd 変換
    payDateValue () {
      return this.toDateValue(this.payDate)
    },
    importPayDateValue () {
      return this.toDateValue(this.importPayDate)
    },
    // サンプルExcel（実ファイルと同じ列並び）。新規タブで開くため token はクエリで渡す
    sampleUrl () {
      var config = this.$store.state.config
      return config.api_method + '://' + config.api_server + '/' + config.api_version +
        '/master/payroll/documents/import_sample?token=' + window.localStorage.getItem('access_token')
    }
  },
  components: {
    AppHeader
  },
  methods: {
    toDateValue: function (date) {
      return date ? date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) : ''
    },
    toggleImport: function () {
      this.importOpen = !this.importOpen
    },
    onFileChange: function (event) {
      var files = event.target.files || event.dataTransfer.files
      this.importFile = (files && files.length > 0) ? files[0] : null
    },
    // Excel取込。支給日は画面の指定を全行に適用する
    submitImport: function () {
      if (!this.importFile || this.importing) {
        return
      }
      if (!this.importPayDateValue) {
        window.alert(this.$t('payroll.message.pay_date_required'))
        return
      }
      var self = this
      this.importing = true
      var formData = new FormData()
      formData.append('document_type', this.importDocumentType)
      formData.append('pay_date', this.importPayDateValue)
      formData.append('file', this.importFile)

      var callback = function () {
        self.importFile = null
        // input[type=file] をクリアする（既存画面と同じ方式）
        self.inputClear = false
        self.$nextTick(function () {
          self.inputClear = true
        })
        // 取り込んだ支給日・種別で一覧を絞り込んで再読込する
        self.payDate = self.importPayDate
        self.documentType = self.importDocumentType
        self.loginId = ''
        self.search()
      }
      this.$store.dispatch('IMPORT_PAYROLL_DOCUMENTS', {data: formData, callback: callback})
      .then(() => { self.importing = false })
      .catch(() => { self.importing = false })
    },
    search: function () {
      var data = {}
      if (this.loginId) {
        data['login_id'] = this.loginId
      }
      if (this.payDateValue) {
        data['pay_date'] = this.payDateValue
      }
      if (this.documentType) {
        data['document_type'] = this.documentType
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_PAYROLL_DOCUMENTS', {data: data, callback: callback})
    },
    showDetail: function (id) {
      this.$store.dispatch('GET_PAYROLL_DOCUMENT', {id: id})
    },
    // 明細PDFをダウンロードする（署名URLは5分・ワンタイム）
    downloadPdf: function () {
      if (!this.document) {
        return
      }
      var callback = function (data) {
        if (data && data.url) {
          window.open(data.url, '_blank')
        }
      }
      this.$store.dispatch('GET_PAYROLL_DOWNLOAD_URL', {id: this.document.id, callback: callback})
    },
    // 金額として表示してよい列か（API の numeric に従う。未定義なら安全側でカンマ区切りしない）
    isAmountRow: function (row) {
      return !!(row && row.numeric)
    },
    // 金額列のみ3桁カンマ区切り。社員番号・氏名・支給日などはそのまま
    formatValue: function (row) {
      if (!row) {
        return ''
      }
      return this.isAmountRow(row) ? utils.formatAmount(row.value) : row.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/payroll-list.js